import jsPDF from 'jspdf';
import 'jspdf-autotable';
import config from "../common/Config";
import axios from 'axios';

const generateUniqueFilename = (baseName, extension) => {
  const timestamp = new Date().toISOString().replace(/[-:.]/g, "");
  return `${baseName}_${timestamp}.${extension}`;
};

const generateSummaryPDF_sdm = async (orderId) => {
  const accessToken = localStorage.getItem('accessToken');
  const company_tax_type = localStorage.getItem("company_tax_type");

  const formData = new FormData();
  formData.set('orderId', orderId);
  const apiUrl = `${config.API_URL}/ws-proforma-invoice`;

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  try {
    const response = await axios.post(apiUrl, formData, {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    });

    const data = response.data;
    console.log(data);

    if (!data.success || !data.details.orderDetails || data.details.orderDetails.length === 0) {
      console.error("No order details found in the response.");
      return;
    }

    const orderDetails = data.details.orderDetails[0];
    const shopDetails = data.details.shop_details;
    const invoiceType = data.details.invoice_type;
    const deliveryDetails = data.details.delivery_details;
    console.log(orderDetails);

    // Check if customer state is Maharashtra for tax logic
    const isMaharashtra = orderDetails.state && orderDetails.state.toLowerCase().includes('maharashtra');

    const totalstd = data.details.product_details
      .filter(item => item.item_tax != '0.00' && item.item_tax != null)
      .reduce((sum, item) => sum + parseFloat(item.subtotal), 0);

    const box_qty = data.details.product_details
      .filter(item => item.quantity != '0.00' && item.quantity != null && item.order_type === 'box')
      .reduce((sum, item) => sum + (parseFloat(item.quantity)), 0);

    const piece_qty = data.details.product_details
      .filter(item => item.quantity != '0.00' && item.quantity != null && item.order_type === 'piece')
      .reduce((sum, item) => sum + (parseFloat(item.quantity)), 0);

    const totalzeroGoods = data.details.product_details
      .filter(item => item.item_tax == '0.00' || item.item_tax === null)
      .reduce((sum, item) => sum + parseFloat(item.subtotal), 0);

    const totalSTDGoods = parseFloat(totalstd);
    const orderDiscount = parseFloat(data.details.orderDetails[0].order_discount) || 0;
    const orderDiscount1 = parseFloat(data.details.orderDetails[0].order_discount) || 0;
    const orderDiscount2 = parseFloat(data.details.orderDetails[0].over_all_discount) || 0;
    let orderDiscount3 = ((totalstd + totalzeroGoods) * (parseFloat(data.details.orderDetails[0].over_all_discount))) / 100 || 0;

    let totalVAT = data.details.product_details
      .filter(item => item.item_tax !== '0.00' || item.item_tax !== null)
      .reduce((sum, item) => sum + (parseFloat(item.item_tax) || 0), 0);

    let totalDiscountOnVat = 0;
    if (parseFloat(data.details.orderDetails[0].over_all_discount) > 0) {
      totalDiscountOnVat += parseFloat(data.details.orderDetails[0].over_all_discount);
    }

    if (data.details.orderDetails[0].percentage !== null) {
      totalDiscountOnVat += parseFloat(data.details.orderDetails[0].percentage);
    }

    const itemTotal = totalstd + totalzeroGoods;
    totalVAT = totalVAT - (totalVAT * totalDiscountOnVat) / 100;
    let over_all_amount = ((totalstd + totalzeroGoods) * (parseFloat(data.details.orderDetails[0].over_all_discount))) / 100;
    let totalAmount = totalstd + totalzeroGoods + totalVAT - parseFloat(data.details.orderDetails[0].order_discount) - over_all_amount;

    // Calculate CGST/SGST or IGST based on state
    let cgstAmount = 0;
    let sgstAmount = 0;
    let igstAmount = 0;

    // Assume tax rate (you might need to get this from your data)
    const taxRate = 18; // Example: 18% GST (9% CGST + 9% SGST for Maharashtra)
    const cgstRate = taxRate / 2; // 9%
    const sgstRate = taxRate / 2; // 9%

    if (isMaharashtra) {
      // For Maharashtra: Split total tax into CGST and SGST (usually 50-50)
      cgstAmount = totalVAT / 2;
      sgstAmount = totalVAT / 2;
    } else {
      // For other states: Use IGST
      igstAmount = totalVAT;
    }

    const addRibbonTitle = (doc, title, fontSize, pageWidth, margin, topMargin) => {
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(fontSize);
      doc.setTextColor(0, 0, 0);
      const titleWidth = doc.getTextWidth(title);
      const titleX = pageWidth - titleWidth - margin;
      const titleY = topMargin + fontSize;
      doc.text(title, titleX, titleY);
    };

    const doc = new jsPDF('portrait');
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 10;
    let y = margin;
    const firstColumnWidth = pageWidth * 0.25;
    const secondColumnWidth = pageWidth * 0.75;
    const H2firstColumnWidth = pageWidth * 0.40;
    const H2secondColumnWidth = pageWidth * 0.25;
    const H2thirdColumnWidth = pageWidth * 0.25;

    // Add the logo image to the header
    const logoUrl = `${config.BASE_URL}/assets/img/${accessToken}_logo.png`;
    const logoWidth = 40;
    const logoHeight = 15;
    doc.addImage(logoUrl, 'PNG', margin, y, logoWidth, logoHeight);
    y += logoHeight + 5;

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(10);
    const title = `${invoiceType}`;
    const fontSize = 10;
    const topMargin = 3;
    addRibbonTitle(doc, title, fontSize, pageWidth, margin, topMargin);
    y += 10;

    const headerSections2 = [
      [],
      [
        { text: `${shopDetails.shop_name}`, size: 13, bold: true },
        { text: `${shopDetails.address.split(',')[0]}`, size: 8, bold: false },
        { text: `${shopDetails.address.split(',')[1]}`, size: 8, bold: false },
        { text: `Company No : ${shopDetails.company_reg_no} | ${company_tax_type} No : ${shopDetails.vat_no}`, size: 8, bold: false },
        { text: `Phone No : ${shopDetails.phone} | Email : ${shopDetails.email}`, size: 8, bold: false },
        { text: `Website : ${shopDetails.website} | AWRS No : ${shopDetails.awrs_no}`, size: 8, bold: false },
      ],
    ];

    const headerSections3 = [
      [
        { text: `Customer Details`, size: 8, bold: true },
        { text: `${orderDetails.company}`, size: 8, bold: true },

        // Dynamic 3-line address split
        ...(() => {
          const parts = orderDetails.address.split(',').map(p => p.trim());
          const chunkSize = Math.ceil(parts.length / 3);
          return [
            { text: parts.slice(0, chunkSize).join(', '), size: 8, bold: false },
            { text: parts.slice(chunkSize, chunkSize * 2).join(', '), size: 8, bold: false },
            { text: parts.slice(chunkSize * 2).join(', '), size: 8, bold: false }
          ];
        })(),

        { text: `${orderDetails.state}`, size: 8, bold: false },
        { text: `${orderDetails.postal_code}`, size: 8, bold: false },
        { text: `Phone No : ${orderDetails.phone} | Email : ${orderDetails.email}`, size: 8, bold: false }
      ],

      [
        { text: `Invoice No : ${orderDetails.reference_no}`, size: 8, bold: false },
        { text: `Invoice Date: ${orderDetails.invoice_date}`, size: 8, bold: false },
        { text: `A/C No: ${orderDetails.account_no}`, size: 8, bold: false },
        { text: `Route No : ${orderDetails.route_number}`, size: 8, bold: false },
        { text: `Order By: ${orderDetails.orderby}`, size: 8, bold: false },
      ],
      [
        { text: `Bank Details`, size: 8, bold: true },
        { text: `${shopDetails.shop_name}`, size: 8, bold: true },
        { text: ``, size: 8, bold: false },
        { text: `A/C No : ${shopDetails.bank_ac}`, size: 8, bold: false },
        { text: `Sort Code: ${shopDetails.sort_code}`, size: 8, bold: false },
      ],
    ];

    const sectionWidth = (pageWidth - margin * 2) / 2;

    // Render header sections
    y = 7;
    const renderSections = (sections, marginTop = 7) => {
      let yPosition = y + marginTop;
      sections.forEach((section, index) => {
        const colStartX = margin + (index % 3) * firstColumnWidth;
        section.forEach((item, i) => {
          doc.setFontSize(item.size);
          doc.setFont(item.bold ? 'helvetica' : 'helvetica', item.bold ? 'bold' : 'normal');
          doc.text(item.text, colStartX, yPosition + i * 4);
        });
        if (index % 4 === 3) {
          yPosition += 12;
        }
      });
      yPosition += 25;
      y = yPosition;
    };

    renderSections(headerSections2);

    const h2renderSections = (sections) => {
      let rowHeight = 0;
      let rowStartY = y;
      let columnHeights = [];

      sections.forEach((section, index) => {
        let colStartX;
        if (index % 3 === 0) {
          colStartX = margin;
        } else if (index % 3 === 1) {
          colStartX = margin + H2firstColumnWidth;
        } else {
          colStartX = margin + H2firstColumnWidth + H2secondColumnWidth;
        }

        let sectionHeight = 0;

        section.forEach((item, i) => {
          doc.setFontSize(item.size);
          doc.setFont(item.bold ? 'helvetica' : 'helvetica', item.bold ? 'bold' : 'normal');

          let maxWidth;
          if (index % 3 === 0) {
            maxWidth = H2firstColumnWidth - 5;
          } else if (index % 3 === 1) {
            maxWidth = H2secondColumnWidth - 5;
          } else {
            maxWidth = H2thirdColumnWidth - 5;
          }

          const textWidth = doc.getTextWidth(item.text);
          let lines = [];
          if (textWidth > maxWidth) {
            let words = item.text.split(' ');
            let line = '';
            words.forEach((word) => {
              const testLine = line + (line ? ' ' : '') + word;
              if (doc.getTextWidth(testLine) <= maxWidth) {
                line = testLine;
              } else {
                lines.push(line);
                line = word;
              }
            });
            lines.push(line);
          } else {
            lines.push(item.text);
          }

          lines.forEach((lineText, lineIndex) => {
            const lineHeight = 4;
            doc.text(lineText, colStartX + 5, y + 5 + i * lineHeight + lineIndex * lineHeight);
            sectionHeight = y + i + lineIndex - 5;
          });
        });

        columnHeights.push(sectionHeight);

        if ((index + 1) % 3 === 0) {
          rowHeight = Math.max(...columnHeights);
          columnHeights = [];

          let colX = margin;
          for (let i = 0; i < 3; i++) {
            doc.setLineWidth(0.1);
            let colWidth = (i === 0) ? H2firstColumnWidth : (i === 1) ? H2secondColumnWidth : H2thirdColumnWidth;
            doc.rect(colX, rowStartY - 2, colWidth, rowHeight + 4);
            colX += colWidth;
          }
          y += rowHeight + 12;
        }
      });
      y += -3;
    };

    h2renderSections(headerSections3);

    // Modified table columns with separate % and Amount columns
    const tableColumns = [
      { title: 'Product', dataKey: 'product', size: 8, bold: true, halign: 'center' },
      { title: 'Type', dataKey: 'order_type', size: 8, bold: true, halign: 'center' },
      { title: 'Qty', dataKey: 'qty', size: 8, bold: true, halign: 'center' },
      { title: 'Price', dataKey: 'unit_price', size: 8, bold: true, halign: 'center' },
      { title: 'Disc', dataKey: 'discount', size: 8, bold: true, halign: 'center' },
    ];

    // Add separate tax columns based on state
    if (isMaharashtra) {
      tableColumns.push(
        { title: 'CGST %', dataKey: 'cgst_percent', size: 8, bold: true, halign: 'center' },
        { title: 'CGST Amt', dataKey: 'cgst_amount', size: 8, bold: true, halign: 'center' },
        { title: 'SGST %', dataKey: 'sgst_percent', size: 8, bold: true, halign: 'center' },
        { title: 'SGST Amt', dataKey: 'sgst_amount', size: 8, bold: true, halign: 'center' }
      );
    } else {
      tableColumns.push(
        { title: 'IGST %', dataKey: 'igst_percent', size: 8, bold: true, halign: 'center' },
        { title: 'IGST Amt', dataKey: 'igst_amount', size: 8, bold: true, halign: 'center' }
      );
    }

    tableColumns.push({ title: 'Total', dataKey: 'net_amount', size: 8, bold: true, halign: 'center' });

    // Calculate the table widths for separate columns - dynamic based on tax type
    const totalWidth = pageWidth - 2 * margin;
    let productWidth, orderTypeWidth, qtyWidth, unitPriceWidth, discountWidth, taxPercentWidth, taxAmountWidth, netAmountWidth;

    if (isMaharashtra) {
      // Maharashtra: CGST + SGST (more columns, less space for product)
      productWidth = totalWidth * 0.35;
      orderTypeWidth = totalWidth * 0.05;
      qtyWidth = totalWidth * 0.05;
      unitPriceWidth = totalWidth * 0.08;
      discountWidth = totalWidth * 0.06;
      taxPercentWidth = totalWidth * 0.06; // Width for % columns
      taxAmountWidth = totalWidth * 0.08;  // Width for Amount columns
      netAmountWidth = totalWidth * 0.10;
    } else {
      // Other states: IGST only (fewer columns, more space for product)
      productWidth = totalWidth * 0.47; // Increased from 0.35 to 0.47
      orderTypeWidth = totalWidth * 0.05;
      qtyWidth = totalWidth * 0.05;
      unitPriceWidth = totalWidth * 0.10; // Slightly increased
      discountWidth = totalWidth * 0.07;  // Slightly increased
      taxPercentWidth = totalWidth * 0.06; // Width for % column
      taxAmountWidth = totalWidth * 0.10;  // Width for Amount column
      netAmountWidth = totalWidth * 0.10;
    }

    // Construct table body with separate % and Amount columns
    const tableBody = data.details.product_details.map((item) => {
      const baseRow = [
        item.product_code + ' - ' + item.product_name + ' - ' + item.size + item.promo_product + item.free_product,
        item.order_type,
        parseInt(item.quantity),
        '' + item.unit_price,
        item.item_discount,
      ];

      // Add separate tax columns
      if (isMaharashtra) {
        const itemTax = parseFloat(item.item_tax) || 0;
        const cgstAmt = (itemTax / 2).toFixed(2);
        const sgstAmt = (itemTax / 2).toFixed(2);

        baseRow.push(
          `${cgstRate}%`,     // CGST %
          cgstAmt,            // CGST Amount
          `${sgstRate}%`,     // SGST %
          sgstAmt             // SGST Amount
        );
      } else {
        baseRow.push(
          `${taxRate}%`,      // IGST %
          item.item_tax       // IGST Amount
        );
      }

      baseRow.push('' + item.subtotal);
      return baseRow;
    });

    // Add total rows
    const totalColSpan = isMaharashtra ? 9 : 7; // Updated for separate columns

    tableBody.push([
      { content: 'Item Total:', colSpan: totalColSpan, styles: { halign: 'right' } },
      { content: `${itemTotal.toFixed(2)}` }
    ]);

    // Tax summary row with separate columns
    if (isMaharashtra) {
      tableBody.push([
        { content: `Total Zero Goods - ${totalzeroGoods.toFixed(2)} | Total Std Goods - ${totalstd.toFixed(2)}`, colSpan: 5, styles: { halign: 'left' } },
        { content: `${cgstRate}%`, styles: { halign: 'center', fontSize: 8, fontStyle: 'bold' } },
        { content: `${cgstAmount.toFixed(2)}`, styles: { halign: 'right', fontSize: 8, fontStyle: 'bold' } },
        { content: `${sgstRate}%`, styles: { halign: 'center', fontSize: 8, fontStyle: 'bold' } },
        { content: `${sgstAmount.toFixed(2)}`, styles: { halign: 'right', fontSize: 8, fontStyle: 'bold' } },
        { content: `${totalVAT.toFixed(2)}` }
      ]);
    } else {
      tableBody.push([
        { content: `Total Zero Goods - ${totalzeroGoods.toFixed(2)} | Total Std Goods - ${totalstd.toFixed(2)}`, colSpan: 5, styles: { halign: 'left' } },
        { content: `${taxRate}%`, styles: { halign: 'center', fontSize: 8, fontStyle: 'bold' } },
        { content: `${igstAmount.toFixed(2)}`, styles: { halign: 'right', fontSize: 8, fontStyle: 'bold' } },
        { content: `${totalVAT.toFixed(2)}` }
      ]);
    }

    if (orderDiscount2 != 0 && orderDiscount2 !== '') {
      tableBody.push([
        { content: `Order Discount (${orderDiscount2}%):`, colSpan: totalColSpan, styles: { halign: 'right', fontSize: 8, fontStyle: 'bold' } },
        orderDiscount3.toFixed(2)
      ]);
    }

    if (orderDiscount1 != 0 && orderDiscount1 !== '') {
      tableBody.push([
        { content: `Promo Discount :`, colSpan: totalColSpan, styles: { halign: 'right', fontSize: 8, fontStyle: 'bold' } },
        orderDiscount.toFixed(2)
      ]);
    }

    tableBody.push([
      { content: `Box : ${box_qty} PCs : ${piece_qty} `, colSpan: totalColSpan - 1, styles: { halign: 'left' } },
      { content: 'Invoice Total:', styles: { halign: 'right', fontSize: 8, fontStyle: 'bold' } },
      { content: `${totalAmount.toFixed(2)}` }
    ]);

    // Column styles configuration for separate columns
    const columnStyles = {
      0: { cellWidth: productWidth, fontSize: 8, fontStyle: 'bold' },
      1: { cellWidth: orderTypeWidth, fontSize: 8, fontStyle: 'bold', halign: 'center' },
      2: { cellWidth: qtyWidth, fontSize: 8, fontStyle: 'bold', halign: 'center' },
      3: { cellWidth: unitPriceWidth, fontSize: 8, fontStyle: 'bold', halign: 'right' },
      4: { cellWidth: discountWidth, fontSize: 8, fontStyle: 'bold', halign: 'center' },
    };

    if (isMaharashtra) {
      columnStyles[5] = { cellWidth: taxPercentWidth, fontSize: 8, fontStyle: 'bold', halign: 'center' }; // CGST %
      columnStyles[6] = { cellWidth: taxAmountWidth, fontSize: 8, fontStyle: 'bold', halign: 'right' };   // CGST Amt
      columnStyles[7] = { cellWidth: taxPercentWidth, fontSize: 8, fontStyle: 'bold', halign: 'center' }; // SGST %
      columnStyles[8] = { cellWidth: taxAmountWidth, fontSize: 8, fontStyle: 'bold', halign: 'right' };   // SGST Amt
      columnStyles[9] = { cellWidth: netAmountWidth, fontSize: 8, fontStyle: 'bold', halign: 'right' };   // Total
    } else {
      columnStyles[5] = { cellWidth: taxPercentWidth, fontSize: 8, fontStyle: 'bold', halign: 'center' }; // IGST %
      columnStyles[6] = { cellWidth: taxAmountWidth, fontSize: 8, fontStyle: 'bold', halign: 'right' };   // IGST Amt
      columnStyles[7] = { cellWidth: netAmountWidth, fontSize: 8, fontStyle: 'bold', halign: 'right' };   // Total
    }

    doc.autoTable({
      startY: y,
      head: [tableColumns.map(col => col.title)],
      body: tableBody,
      theme: 'grid',
      headStyles: {
        fillColor: '#f8f9fa',
        textColor: '#404040',
        fontSize: 8,
        valign: 'middle',
        lineWidth: 0.3,
        halign: 'center',
        lineColor: [0, 0, 0]
      },
      bodyStyles: {
        fontSize: 8,
        valign: 'middle',
        lineWidth: 0.3,
        lineColor: [0, 0, 0]
      },
      margin: { top: 0, left: margin, right: margin },
      columnStyles: columnStyles,
    });

    y = doc.autoTable.previous.finalY + 5;

    const addFooterSection = (footerSection) => {
      footerSection.forEach((section, index) => {
        const colStartX = margin + (index % 4) * sectionWidth;
        section.forEach((item, i) => {
          doc.setFontSize(item.size);
          doc.setFont(item.bold ? 'helvetica' : 'helvetica', item.bold ? 'bold' : 'normal');
          doc.text(item.text, colStartX, y + i * 5);
        });
        if (index % 4 === 3) {
          y += 20;
        }
      });
      y += 25;
    };

    const addFooterWithSpaceCheck = (footerSection) => {
      const remainingSpace = pageHeight - y - margin;
      const requiredSpace = footerSection.length * 5 + 20;
      if (remainingSpace < requiredSpace) {
        doc.addPage();
        y = margin;
      }
      addFooterSection(footerSection);
      y += 10;
    };

    const footerSections2 = [
      [
        { text: 'Delivery Checked & Collected By : _ _ _ _ _ _ _ _ _', size: 8, bold: false },
        { text: 'Amt Paid :_ _ _ _ _ _ _ _ _ _Collected By :_ _ _ _ _ _ _ _ _ _ ', size: 8, bold: false },
        { text: 'Terms -', size: 8, bold: false },
        { text: `1 - Once delivery is received ${shopDetails.shop_name} is not responsible for any damage or loss `, size: 8, bold: false },
        { text: `2 - Goods remain the property of ${shopDetails.shop_name} until invoice fully paid `, size: 8, bold: false },
        { text: `3 - No claims for damages or short delivery will be considered unless made at the time of delivery of goods.`, size: 8, bold: false },
        { text: `4 - There is No Refund Policy Of goods sold`, size: 8, bold: false },
      ]
    ];

    addFooterWithSpaceCheck(footerSections2);

    const footerSections3 = [
      [
        { text: `Staff Note: ${orderDetails.staff_note}`, size: 8, bold: true },
        { text: `Note For Driver: ${orderDetails.note_for_driver}`, size: 8, bold: true },
      ]
    ];

    addFooterWithSpaceCheck(footerSections3);

    if (Array.isArray(deliveryDetails) && deliveryDetails.length > 0) {
      const boxMarginTop = 5;
      const boxHeight = 20;
      const boxWidth = pageWidth - 2 * margin;
      let boxY = y + boxMarginTop;

      if (boxY + boxHeight > pageHeight - margin) {
        doc.addPage();
        boxY = margin + boxMarginTop;
      }

      doc.setLineWidth(0.2);
      doc.rect(margin, boxY, boxWidth, boxHeight);

      doc.setFontSize(10);
      doc.setFont('helvetica', 'bold');
      let collectedByText = 'Goods Collected By:';
      let signatureText = 'Signature:';

      const recipient = deliveryDetails[0];
      if (recipient.received_by) {
        collectedByText = `Goods Collected By: ${recipient.received_by}`;
      }

      doc.text(collectedByText, margin + 5, boxY + 15);
      doc.text(signatureText, margin + boxWidth / 2 + 5, boxY + 15);
      doc.line(margin + boxWidth / 2 + 25, boxY + 15, margin + boxWidth - 10, boxY + 15);

      if (Array.isArray(deliveryDetails) && deliveryDetails.length > 0) {
        const recipient = deliveryDetails[0];
        if (recipient.recipient_signature) {
          const sigWidth = 15;
          const sigHeight = 10;
          const sigAreaStart = margin + boxWidth / 2 + 15;
          const sigAreaEnd = margin + boxWidth - 10;
          const sigX = sigAreaStart + ((sigAreaEnd - sigAreaStart) - sigWidth) / 2;
          const sigY = boxY + 4;
          doc.addImage(recipient.recipient_signature, 'PNG', sigX, sigY, sigWidth, sigHeight);
        }
      }

      y = boxY + boxHeight + 5;
    }

    const addPageNumbers = (doc) => {
      const pageCount = doc.internal.getNumberOfPages();
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(8);
        const pageNumberText = `Page ${i} of ${pageCount}`;
        const textWidth = doc.getTextWidth(pageNumberText);
        const xPosition = pageWidth - textWidth - 10;
        doc.text(pageNumberText, xPosition, pageHeight - 12);
      }
    };

    addPageNumbers(doc);
    const filename = generateUniqueFilename('Invoice', 'pdf');
    doc.autoPrint();
    window.open(doc.output('bloburl'));

  } catch (error) {
    console.error('Error generating PDF:', error);
  }
};

export default generateSummaryPDF_sdm;